var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasDownloadLogId
    ? _c(
        "el-button",
        {
          staticClass: "download-file-button",
          attrs: { type: "text", disabled: _vm.loading || _vm.disabled },
          on: { click: _vm.download },
        },
        [
          _c("i", { staticClass: "el-icon-download" }),
          _vm._v(
            "\n  " +
              _vm._s(
                _vm.loading ? _vm.$t("downloadLogUi.loading") : _vm.displayLabel
              ) +
              "\n"
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }